import { QueryKey, useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import queryString from 'query-string';
import { MetricEntry } from './types';
import { prefetchData } from './prefetchData';

const getConditionsOperators = async ({ signal }: { signal?: AbortSignal }): Promise<MetricEntry[]> => {
  const res = await apiClient.get<{ data: MetricEntry[] }>(`/conditions/operators`, {
    signal,
    paramsSerializer: (prms) => queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return res.data.data;
};

interface UseConditionsOperators<TData> {
  config?: QueryConfig<typeof getConditionsOperators, TData>;
}

export const useConditionsOperators = <TData = MetricEntry[]>({ config }: UseConditionsOperators<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getConditionsOperators({ signal }),
    queryKey: ['conditions', 'operators'] as QueryKey,
  });
};

export const prefetchConditionsOperators = async () =>
  await prefetchData(getConditionsOperators, ['conditions', 'operators'] as const);
